import React from 'react';
import {observer} from "mobx-react";
import {PropositionBetsWidgetRow} from "./proposition-bets-widget.row";

export const PropositionBetsWidgetRows = observer(({controller, currentRows, bet}) => {
  return currentRows?.map(row => <PropositionBetsWidgetRow row={row}
                                                           bet={bet}
                                                           controller={controller}
                                                           key={row.athleteId}/>)
});
